module.exports = __webpack_public_path__ + "pen.jpg?c1be3b8bf9b72036ec087badb195b375";